<template>
  <div class="c-material-report">
    <m-content v-model="height" :total="total">
      <p-detail-filter ref="filter" slot="filter" v-model="isShow" @on-change="filterData" @on-search="searchFilterData" />
      <div class="c-m-table">
        <div class="c-table-list">
          <div class="table-btns-row">
            <Dropdown @on-click="batchAction">
              <Button>批量操作 <Icon type="ios-arrow-down"></Icon> </Button>
              <DropdownMenu slot="list">
                <DropdownItem name="budget">批量修改账号预算</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button icon="md-download" @click="downData" :loading="exportLoading" class="i-button">数据导出</Button>
            <Button @click="syncMaterialGdtv3" class="i-button" :loading="syncMaterialGdtv3Loading">同步腾讯3.0手动上传素材</Button>

            <QueryParamsManager
              ref="queryParamsManager"
              menu-id="M20847"
              :max-conditions="20"
              @select="onConditionSelect"
              @request-save="onSaveRequest"
            />
          </div>

          <div>
            <DropdownNavigator style="margin-right: 10px"></DropdownNavigator>

            <Button style="margin-right: 10px" @click="modalColumn = true">自定义列</Button>

            <DateRangePicker v-model="datetime" style="width: 220px" :clearable="false"></DateRangePicker>
          </div>
        </div>
        <p-detail-table
          ref="planDataTable"
          :height="height"
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @on-sort="sortTable"
          @on-map="showDetail"
          @header-dragend="headerDragend"
          @on-refresh="getData"
        />
      </div>

      <Page
        slot="pagination"
        v-if="total"
        show-total
        show-sizer
        show-elevator
        class="c-table-page"
        size="small"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSizePrivate"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSizePrivate"
      />
    </m-content>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      name="ActDataCustomColumn"
      v-model="modalColumn"
      :data="rawTableCols"
      :sub-title="['基础信息', '报表数据', '留存数据']"
      @on-select="onTableColsChange"
    />
    <Modal
      width="700"
      v-model="syncMaterialGdtv3Modal"
      title="素材同步结果"
      :mask-closable="false"
      class-name="vertical-center-modal"
      @on-ok="$emit('on-ok')"
    >
      <Table height="440" :columns="syncMaterialGdtv3Columns" :data="syncMaterialGdtv3Data">
        <template slot-scope="{ row }" slot="status">
          <div v-if="row.status === 'all'" class="m-icon">
            <Icon type="ios-checkmark-circle" size="24" color="#19BE6B" />
            <div>成功</div>
          </div>
          <div v-if="row.status === 'part'" class="m-icon">
            <Icon type="ios-alert" size="24" color="#FF9900" />
            <div>部分成功</div>
          </div>
          <div v-if="row.status === 'fail'" class="m-icon">
            <Icon type="ios-close-circle" size="24" color="#DC362E" />
            <div>失败</div>
          </div>
        </template>
      </Table>
    </Modal>
  </div>
</template>
<script>
import { isArray, isEmpty, throttle, formatDate } from '@/common/js/utils'
import mixinTable from './mixin_table'
import columns from '../data/accountdata_column.js'
import CustomColumn from '@/components/converter/custom-column2.vue'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import PDetailFilter from './components/act-filter.vue'
import PDetailTable from './components/act-table.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import DropdownNavigator from '@/components/new-plan-dropdown-nav'
import { initDownloadCenterTask } from '@/api/report.model'
import { getPtomActData, exportPtomActData } from '@/api/ptom.data.model'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { syncAccountMaterial } from '@/api/common.model'
import { PTOM_PLAN_ACCOUNT } from '@/views/download-center/data/const'

const now = formatDate(new Date(), 'yyyy-MM-dd')
export default {
  name: 'accountList',
  mixins: [mixinTable],
  components: {
    CustomColumn,
    PDetailFilter,
    PDetailTable,
    // ConditionFilter,
    QueryParamsManager,
    DropdownNavigator,
    DateRangePicker
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  methods: {
    showDetail(row) {
      const { adAccountId } = row
      const query = { map: 'out', beginTime: this.datetime[0], endTime: this.datetime[1] } // , sort: this.sort, order: this.order 带排序两次请求
      adAccountId && Object.assign(query, { adAccountId })
      if (this.params) {
        const { gameId, gameGroupId, opId, projectGroupOpIds, mediaId, platform, advPositionId, optimizationType, deepOptimizationType } =
          this.params
        gameId && Object.assign(query, { gameId })
        gameGroupId && Object.assign(query, { gameGroupId })
        opId && Object.assign(query, { opId })
        projectGroupOpIds && Object.assign(query, { projectGroupOpIds })
        mediaId && Object.assign(query, { mediaId })
        platform && Object.assign(query, { platform })
        advPositionId && Object.assign(query, { advPositionId })
        optimizationType && Object.assign(query, { optimizationType })
        deepOptimizationType && Object.assign(query, { deepOptimizationType })
      }
      this.$router.push({ name: 'plandatadetail', query })
    },
    getData(filter) {
      if (this.loading) return

      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSizePrivate,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getPtomActData(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        if (isArray(list) && page_info && sum_data) {
          const { total_number } = page_info
          this.sumdata = sum_data
          this.total = total_number || 0
          this.tableList = list.map((ret) => {
            return {
              ...ret,
              showAccountBudgetActionPopover: false, // 显示账号编辑定时预算操作popover
              showAccountBudgetEditPopover: false, // 显示账号编辑定时预算更改input popover

              reserveBudgetRadio: ret.bookAccountBudget > 0 ? 1 : 0,
              bookAccountBudgetDup: ret.bookAccountBudget, // 保存账号预算预约预算值副本，用于v-model接收新的预算

              isAccountReserveModifyBudget: ret.bookAccountBudget > 0 || ret.bookAccountBudget === 0
            }
          })
        } else this.tableList = []
        this.$nextTick(() => {
          this.$refs.planDataTable && this.$refs.planDataTable.doLayout()
        })
      })
    },
    downData() {
      const exportColumnOrderMap = {}
      this.tableColumns.forEach((col) => {
        if (col.checked && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })
      this.exportLoading = true
      const conditionText = this.$refs.filter.getTransferedTaskQueryConditions(this.params, PTOM_PLAN_ACCOUNT)

      initDownloadCenterTask({
        pageType: PTOM_PLAN_ACCOUNT,
        queryCondition: { ...this.params, exportColumnOrderMap, conditionText }
      }).then((data) => {
        this.exportLoading = false
        if (data.msg) {
          this.$Message.success(data.msg)
          this.$store.commit('setDownloadBadgeActive', 1)
        }
      })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const twoDecimal = ['pv', 'clickNum', 'paperUseAmount', 'amount', 'newRoleMoney', 'newDeviceMoney', 'sumMoney']
        if (!prop || ['deductRate'].includes(prop)) sums[index] = ''
        else if (prop.indexOf('Rate') > -1 || prop.indexOf('Retain') > -1 || prop.indexOf('RoleRoi') > -1 || ['sumRebate'].includes(prop)) {
          sums[index] = toPercentFixed(data[prop])
        } else if (twoDecimal.includes(prop)) sums[index] = toThousands(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    changePageSizePrivate(size) {
      this.pageSizePrivate = size
      if (this.pageIndex === 1) this.getData()
    },

    onSaveRequest() {
      this.$nextTick(() => {
        const params = this.$refs.filter.buildParams()
        this.$refs.queryParamsManager.openSaveDialog(params)
      })
    },
    onConditionSelect(cond) {
      if (this.$refs.filter && cond) {
        const { id, conditionInfo } = cond
        if (!isEmpty(conditionInfo)) {
          let projectGroupId, adAccountId
          const {
            adAccountIdStr,
            gameId,
            gameGroupId,
            opId,
            projectGroupOpIds,
            mediaId,
            managerId,
            platform,
            advPositionId,
            optimizationType,
            deepOptimizationType,
            order,
            sort
          } = JSON.parse(conditionInfo)

          !isEmpty(sort) && (this.sort = sort)
          !isEmpty(order) && (this.order = order)
          !isEmpty(projectGroupOpIds) && (projectGroupId = projectGroupOpIds.split(',').map((ret) => Number(ret)))
          !isEmpty(adAccountIdStr) && (adAccountId = adAccountIdStr.split(',').map((ret) => Number(ret)))

          this.$nextTick(() => {
            Object.assign(this.$refs.filter, {
              projectGroupId: projectGroupId || '',
              accountId: adAccountId || '',
              gameId: gameId || '',
              gameGroupId: gameGroupId || '',
              opId: opId || '',
              managerId: managerId || '',
              mediaId: mediaId || '',
              platform: platform ? (Number(platform) ? platform : '') : '',
              AdvertPositionId: advPositionId || '',
              optimizationType: optimizationType || '',
              deepOptimizationType: deepOptimizationType || ''
            })
          })
        }
      }
    },

    batchAction(cmd) {
      const selectList = this.$refs.planDataTable.getSelectList()

      if (!selectList?.length) return this.$Message.info('请选择至少一个账号！')

      switch (cmd) {
        case 'budget':
          this.$refs.planDataTable.showAccountBatchBudgetModal()
          break
        default:
          break
      }
    },

    headerDragend({ n, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.modalColumn = false
    },
    syncMaterialGdtv3() {
      const selectList = this.$refs.planDataTable.getSelectList()
      if (!selectList || selectList.length === 0) {
        this.$Message.info('请选择至少一个账号！')
        return
      }
      this.syncMaterialGdtv3Loading = true
      syncAccountMaterial({ accountIds: selectList.map((s) => s.adAccountId) }).then((data) => {
        this.syncMaterialGdtv3Data = data
        this.syncMaterialGdtv3Modal = true
        this.syncMaterialGdtv3Loading = false
      })
    }
  },
  watch: {
    datetime() {
      throttle(() => {
        this.pageIndex = 1
        if (this.params) this.$refs.filter.sendEvent()
        else this.getData({})
      }, 600)()
    }
  },
  data() {
    return {
      datetime: [],
      height: 0,

      modalColumn: false,
      isShow: false, // 筛选器是否显示
      pageSizePrivate: 20, // 自定义默认页面尺寸
      rawTableCols: columns, // 表格字段
      tableColumns: [], // 表格字段
      tableList: [], // 表格数据
      sumdata: [], // 合计数据
      AdvertPositionOriginalData: [],
      projectGroupData: [],
      accountData: [],
      gameData: [],
      mediaData: [],
      operatorData: [],
      managerData: [],
      groupData: [],

      exportLoading: false,
      syncMaterialGdtv3Loading: false,
      syncMaterialGdtv3Modal: false,
      syncMaterialGdtv3Data: [],
      syncMaterialGdtv3Columns: [
        {
          key: 'accountName',
          title: '账号名称',
          tooltip: true,
          minWidth: 100
        },
        {
          key: 'syncMaterailNames',
          title: '本次(同步/更新)素材',
          tooltip: true,
          minWidth: 200
        },
        {
          slot: 'status',
          title: '结果',
          tooltip: true,
          minWidth: 100
        },
        {
          key: 'errorMsg',
          title: '报错信息',
          tooltip: true,
          minWidth: 200
        }
      ]
    }
  },
  created() {
    this.datetime = [now, now]
  }
}
</script>
<style lang="scss" scoped>
.c-material-report {
  height: 100%;

  .c-btn-group {
    line-height: 30px;
    height: 32px;
    border-radius: 3px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
  }

  .c-table-list {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .table-btns-row {
      .ivu-btn {
        margin-right: 3px;
      }
    }
  }

  .c-table-page {
    padding: 8px 8px 0;
    text-align: right;
  }
}
.m-icon {
  display: flex;
  div {
    display: inline;
    line-height: 24px;
  }
}
</style>
